import { CONTRAT_ETAT_ENREGISTRE, CONTRAT_ETAT_BROUILLON } from '@/configuration/baux/contrat/contratConf';

export default function genererCritereRechercheContrat() {
  return {
    auto: null,
    tiersId: [],
    societeId: null,
    codes: [],
    etat: [CONTRAT_ETAT_ENREGISTRE, CONTRAT_ETAT_BROUILLON],
    naturesId: [],
    contratType: [],
    periodeContrats: {
      dateDebut: null,
      dateFin: null,
    },
    datePreavis: {
      dateDebut: null,
      dateFin: null,
    },
    codesFace: [],
    agencesId: [],
    responsableBailIds: [],
    demarcheurIds: [],
    estIndexe: null,
    motifsBlocagesId: [],
    blocagePaiement: null,
    paiementSurFacture: null,
    departements: [],
    secteurIds: [],
    hasSecteur: null,
    exclureVilles: [],
    etatRenouvellement: [],
    motifNonRenouvellement: [],
  };
}
